import React from "react";
import AnimatedRoutes from "./game/crazy/AnimatedRoutes";
import Credits from "./game/crazy/Credits";

export default function App() {
  return <AnimatedRoutes />;
}
